import React, { useEffect, useState } from "react";
import { FieldArray, FormikErrors, useFormik } from "formik";
import { AddPhotoAlternate, Close, Delete } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { colors } from "../../../customer/data/Filter/color";
import { mainCategory } from "../../../customer/data/mainCategory";
import { menLevelTwo } from "../../../customer/data/levelTwo/menLevelTwo";
import { womenLevelTwo } from "../../../customer/data/levelTwo/womenLevelTwo";
import { electronicsLevelTwo } from "../../../customer/data/levelTwo/electronicsLevelTwo";
import { furnitureLevelTwo } from "../../../customer/data/levelTwo/funitureLevelTwo";
import { beautyLevelTwo } from "../../../customer/data/levelTwo/beautyLevelTwo";
import { menLevelThree } from "../../../customer/data/levelThree/menLevelThree";
import { womenLevelThree } from "../../../customer/data/levelThree/womenLevelThree";
import { electronicsLevelThree } from "../../../customer/data/levelThree/electronicLevelThree";
import { furnitureLevelThree } from "../../../customer/data/levelThree/funitureLevelThree";
import { beautyLevelThree } from "../../../customer/data/levelThree/beautyLevelThree";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import {
  editProduct,
  getproductById,
} from "../../../State/seller/sellerProductSlice";
import { useNavigate, useParams } from "react-router-dom";
import { ProductDetailVariant } from "../../components/ProductDetailVariant";
import {  Category, ProductDetail, ProductReq } from "../../../types/productType";
import { FormikProvider } from "formik";
import { uploadImageToCloudinary } from "../../../State/seller/sellerUploadToCloudinary";
import { categoryTwo, categoryThree } from "../../../customer/components/CategorySheet";
import { getCategoryLevelsFromId } from "../../../customer/data/Filter/categoryFilter";


const validationSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  mrpPrice: Yup.number()
    .required("MRP Price is required")
    .positive("Price must be positive"),
  sellingPrice: Yup.number()
    .required("Selling Price is required")
    .positive("Price must be positive"),
  quantity: Yup.number()
    .required("Quantity is required")
    .min(1, "At least 1 item must be in stock"),
  images: Yup.array().min(1, "At least one image is required"),
  category: Yup.string().required("Category is required"),
  category2: Yup.string().required("Category 2 is required"),
  category3: Yup.string().required("Category 3 is required"),
  details: Yup.array()
    .of(
      Yup.object({
        size: Yup.string().required("Size is required"),
        color: Yup.string().required("Color is required"),
        sellingPrice: Yup.number()
          .typeError("Must be a number")
          .min(0)
          .required("Required"),
        stock: Yup.number()
          .typeError("Must be a number")
          .min(0)
          .integer()
          .required("Required"),
      })
    )
    .min(1, "Add at least one detail")
    .test("uniq-size-color", "Duplicate size + color not allowed", (arr) => {
      if (!arr) return true;
      const seen = new Set<string>();
      for (const r of arr) {
        const key = `${r.size}__${r.color}`;
        if (!r.size || !r.color) continue;
        if (seen.has(key)) return false;
        seen.add(key);
      }
      return true;
    }),
});
export const EditProducts = () => {
  const [selectedIdx, setSelectedIdx] = useState<number>(0);

  const dispatch = useAppDispatch();
  const { sellerProduct } = useAppSelector((store) => store);
  const navigate = useNavigate();
  const { productId } = useParams();
  const emptyRow = { size: "", color: "", sellingPrice: 0, stock: 0 };
  const mapDetail = (d: any): ProductDetail => ({
    size: d?.size ?? "",
    color: d?.color ?? "",
    sellingPrice: Number(d?.sellingPrice ?? 0),
    stock: Number(d?.stock ?? 0),
  });
  const initialValues = React.useMemo<ProductReq>(() => {
  const p = sellerProduct.product;
  const categoryIdLevel3 = p?.category?.categoryId;

  // Default nếu không có category
  let level1Id = "";
  let level2Id = "";
  let level3Id = "";

  if (categoryIdLevel3) {
    const { level1, level2, level3 } =
      getCategoryLevelsFromId(categoryIdLevel3);

    level1Id = level1?.categoryId ?? "";
    level2Id = level2?.categoryId ?? "";
    level3Id = level3?.categoryId ?? "";
  }
  return {
    title: p?.title ?? "",
    description: p?.description ?? "",
    mrpPrice: Number(p?.mrpPrice ?? 0),
    sellingPrice: Number(p?.sellingPrice ?? 0),
    quantity: Number(p?.quantity ?? 0),
    images: p?.images ?? [],
    // 👇 assuming your Selects use numeric categoryId as values
    category: level1Id ?? "",
    category2: level2Id ?? "",
    category3: level3Id ?? "",
    discountPercentage: Number(p?.discountPercentage ?? 0),
    // ⚠️ DO NOT put new Date() here, it re-triggers reinitialize every render
    details: p?.details?.length ? p.details.map(mapDetail) : [emptyRow],
  };
}, [sellerProduct.product?.id]); // re-init only when product actually changes
  const formik = useFormik<ProductReq>({
    initialValues,
    enableReinitialize: true,
   
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Submit logic here
      const req = {
        ...values,
        details: values.details.map((d) => ({
          // include id if existing row
          size: d.size,
          color: d.color,
          sellingPrice: Number(d.sellingPrice),
          stock: Number(d.stock),
        })),
      };
      await dispatch(
        editProduct({ req: values, productId: sellerProduct.product?.id })
      );
      navigate("/seller/products");
    },
  });
  const [uploadImage, setUploadImage] = useState(false);


  // Filtering out category child match with parent category
  const childCategory = (category: any, parentCategoryId: any) => {
    return category.filter((child: any) => {
      return child.parentCategoryId == parentCategoryId;
    });
  };


// Tạo 1 lần ở ngoài component (hoặc dùng useMemo)



  //Formik's setFieldValue directly updates the field's value without needing to rely on a predefined onChange handler.
  // It's particularly useful for custom inputs or operations, like uploading files or handling complex data structures.
  const handleRemoveImage = (index: number) => {
    // Remove the image at the specified index
    const updatedImages = [...(formik.values.images || [])];
    // remove the image from the images array
    updatedImages.splice(index, 1);
    // Update the images field in Formik
    formik.setFieldValue("images", updatedImages);
  };
  // Since the image upload is triggered directly from the onChange event of the file input, there's no need to use a useEffect in this case. The handleImageChange function takes care of managing the image upload and updating the form state.
  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    try {
      setUploadImage(true);
      const url = await dispatch(uploadImageToCloudinary(file)).unwrap();
      formik.setFieldValue("images", [...formik.values.images, url]);
    } catch (err) {
      console.error(err);
    } finally {
      setUploadImage(false);
    }
  };

  useEffect(() => {
    if (productId) {
      const parsedProductId = parseInt(productId as string, 10);
      dispatch(getproductById(parsedProductId)).unwrap();
    }
  }, [dispatch, productId]);

 // ✅ Runs only when `sellerProduct` updates
  if (!sellerProduct?.product) {
    return <p>Loading product details...</p>; // ✅ Prevents rendering before data is ready
  }
  // Solution: Use useEffect to update Formik state when sellerProduct changes instead of using enableReinitialize.

  return (
    <FormikProvider value={formik}>
      <form
        onSubmit={(e) => {
          e.preventDefault(); // Prevent default form submission
          formik.handleSubmit(e);
        }}
        onInvalid={(e) => {
          // will fire if native invalid happens
          
        }}
        className="space-y-4 p-4"
      >
        {sellerProduct?.product && (
          <Grid2 container spacing={2}>
            <Grid2 className="flex flex-wrap gap-5" size={{ xs: 12 }}>
              {/* Render existing images */}

              {/* Hidden File Input */}
              <input
                type="file"
                accept="image/*"
                id="fileInput"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />

              {/* Custom Button for File Input */}
              <label htmlFor="fileInput" className="relative">
                <span className="w-24 h-24 cursor-pointer flex items-center justify-center border rounded-md">
                  <AddPhotoAlternate className="text-gray-700" />
                </span>
                {/* Show Circular Progress if Uploading */}
                {uploadImage && (
                  <div className="absolute left-0 right-0 top-0 bottom-0 w-24 h-24 flex items-center justify-center">
                    <CircularProgress />
                  </div>
                )}
              </label>
              <div className="flex flex-wrap gap-2">
                {(formik.values.images || []).map(
                  (image: string, index: number) => (
                    <div className="relative" key={index}>
                      {/* Render the uploaded image */}
                      <img
                        className="w-24 h-24 object-cover"
                        key={index}
                        src={image}
                        alt={`ProductImage ${index + 1}`}
                      />

                      {/* Render the delete button */}
                      <IconButton
                        onClick={() => handleRemoveImage(index)}
                        className=""
                        size="small"
                        color="error"
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          outline: "none",
                        }}
                      >
                        <Close />
                      </IconButton>
                    </div>
                  )
                )}
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <TextField
                fullWidth
                id="title"
                name="title"
                label="Title"
                value={formik.values.title}
                onChange={formik.handleChange}
                error={formik.touched.title && Boolean(formik.errors.title)}
                helperText={formik.touched.title && formik.errors.title}
                required
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <TextField
                fullWidth
                id="quantity"
                name="quantity"
                label="Quantity"
                type="number"
                value={formik.values.quantity}
                onChange={formik.handleChange}
                error={
                  formik.touched.quantity && Boolean(formik.errors.quantity)
                }
                helperText={formik.touched.quantity && formik.errors.quantity}
                required
              />
              <h1 className="pt-3">Product Details:</h1>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12 }}>
              <FieldArray
                name="details"
                render={(helpers) => (
                  <>
                    {formik.values.details.map((row, idx) => (
                      <ProductDetailVariant
                        isOnlyProduct={formik.values.details.length === 1}
                        key={idx}
                        idx={idx}
                        values={row} // 👈 pass row directly
                        handleChange={formik.handleChange}
                        touched={formik.touched.details?.[idx]}
                        errors={
                          formik.errors.details?.[idx] as
                            | FormikErrors<ProductDetail>
                            | undefined
                        }
                        onRemove={() => helpers.remove(idx)}
                        disableRemove={formik.values.details.length === 1}
                        onActivate={() => setSelectedIdx(idx)}
                      />
                    ))}

                    <div className="w-full flex justify-between ">
                      <Grid2>
                        <Button
                          variant="outlined"
                          onClick={() => helpers.push(emptyRow)} // 👈 this now works fine
                        >
                          Add More Product Details
                        </Button>
                      </Grid2>
                      <Grid2>
                     
                      </Grid2>
                    </div>
                  </>
                )}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 12 }}>
              <TextField
                multiline
                rows={9}
                fullWidth
                id="description"
                name="description"
                label="Description"
                value={formik.values.description}
                onChange={formik.handleChange}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
                required
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4, lg: 3 }}>
              <TextField
                fullWidth
                id="sellingPrice"
                name="sellingPrice"
                label="Selling Price"
                type="number"
                value={formik.values.sellingPrice}
                onChange={formik.handleChange}
                error={
                  formik.touched.sellingPrice &&
                  Boolean(formik.errors.sellingPrice)
                }
                helperText={
                  formik.touched.sellingPrice && formik.errors.sellingPrice
                }
                required
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4, lg: 3 }}>
              <TextField
                fullWidth
                id="mrp_price"
                name="mrpPrice"
                label="MRP Price"
                type="number"
                value={formik.values.mrpPrice}
                onChange={formik.handleChange}
                error={
                  formik.touched.mrpPrice && Boolean(formik.errors.mrpPrice)
                }
                helperText={formik.touched.mrpPrice && formik.errors.mrpPrice}
                required
              />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <FormControl
                fullWidth
                error={
                  formik.touched.category && Boolean(formik.errors.category)
                }
                required
              >
                <InputLabel id="category-label">Category</InputLabel>
                <Select
                  labelId="category-label"
                  id="category"
                  name="category"
                  value={formik.values.category}
                  onChange={formik.handleChange}
                  label="Category"
                >
                  {mainCategory.map((item) => (
                    <MenuItem key={item.categoryId} value={item.categoryId}>
                      {item.name || "Undefined Category"}
                    </MenuItem>
                  ))}
                </Select>
                {formik.touched.category && formik.errors.category && (
                  <FormHelperText>{formik.errors.category}</FormHelperText>
                )}
              </FormControl>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <FormControl
                fullWidth
                error={
                  formik.touched.category && Boolean(formik.errors.category)
                }
                required
              >
                <InputLabel id="category2-label">Second Category</InputLabel>
                <Select
                  labelId="category2-label"
                  id="category2"
                  name="category2"
                  value={formik.values.category2}
                  onChange={formik.handleChange}
                  label="Second Category"
                >
                  {(categoryTwo[formik.values.category] || []).map((item) => (
                    <MenuItem key={item.categoryId} value={item.categoryId}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
                {formik.touched.category && formik.errors.category && (
                  <FormHelperText>{formik.errors.category}</FormHelperText>
                )}
              </FormControl>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
              <FormControl
                fullWidth
                error={
                  formik.touched.category && Boolean(formik.errors.category)
                }
                required
              >
                <InputLabel id="category3-label">Third Category</InputLabel>
                <Select
                  labelId="category3-label"
                  id="category3"
                  name="category3"
                  value={formik.values.category3}
                  onChange={formik.handleChange}
                  label="Third Category"
                >
                  {(categoryThree[formik.values.category] || [])
                    .filter(
                      (item) =>
                        item.parentCategoryId === formik.values.category2
                    )
                    .map((item) => (
                      <MenuItem key={item.categoryId} value={item.categoryId}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
                {formik.touched.category3 && formik.errors.category3 && (
                  <FormHelperText>{formik.errors.category3}</FormHelperText>
                )}
              </FormControl>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Button
                sx={{ p: "14px" }}
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
                disabled={formik.isSubmitting}
              >
                {false ? (
                  <CircularProgress
                    size="small"
                    sx={{ width: "27px", height: "27px" }}
                  />
                ) : (
                  "Save Product"
                )}
              </Button>
            </Grid2>
          </Grid2>
        )}
      </form>
    </FormikProvider>
  );
};
